import React from "react";
import { useStoreState, useStoreActions } from "easy-peasy";

export default function Calendar({ data, isDateSelected, setDateSelected }) {
  const setDates = useStoreActions((actions) => actions.setDates);
  const dates = useStoreState((state) => state.dates);
  const activeDate = useStoreState((state) => state.activeDate);
  const isCopticCal = useStoreState((state) => state.isCopticCal);

  return (
    <div>
      <div className="calendar">
        <div>S</div>
        <div>M</div>
        <div>T</div>
        <div>W</div>
        <div>T</div>
        <div>F</div>
        <div>S</div>
        {data.length > 0 &&
          [...Array(data[0][1]).keys()].map((x) => <div key={"empty_" + x} />)}
        {data.map((x, i) =>
          isDateSelected &&
          (isCopticCal
            ? Number(activeDate.copticDate?.date) === i + 1
            : Number(activeDate.normalDate?.date) === i + 1) ? (
            <div
              className="activeDate"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setDateSelected(true);
                setDates({
                  date: i + 1,
                  month: dates.month,
                  year: dates.year,
                });
              }}
              key={i + 1}
            >
              <div>{i + 1}</div>
            </div>
          ) : (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                setDateSelected(true);
                setDates({
                  date: i + 1,
                  month: dates.month,
                  year: dates.year,
                });
              }}
              key={i + 1}
            >
              {i + 1}
            </div>
          )
        )}
      </div>
    </div>
  );
}
